export interface LmiCategory {
  name: string;
  translationKey?: string;
  categoryId: string;
}

export const LMI_CATEGORIES: LmiCategory[] = [
  {
    name: 'Listings',
    translationKey: 'COMMON.LMI_CATEGORIES.LISTINGS',
    categoryId: 'listings',
  },
  {
    name: 'Social',
    translationKey: 'COMMON.LMI_CATEGORIES.SOCIAL',
    categoryId: 'social',
  },
  {
    name: 'Reputation',
    translationKey: 'COMMON.LMI_CATEGORIES.REPUTATION',
    categoryId: 'reputation',
  },
  {
    name: 'SEO',
    translationKey: 'COMMON.LMI_CATEGORIES.SEO',
    categoryId: 'seo',
  },
  {
    name: 'Website',
    translationKey: 'COMMON.LMI_CATEGORIES.WEBSITE',
    categoryId: 'website',
  },
  {
    name: 'Advertising',
    translationKey: 'COMMON.LMI_CATEGORIES.ADVERTISING',
    categoryId: 'advertising',
  },
  {
    name: 'Content',
    translationKey: 'COMMON.LMI_CATEGORIES.CONTENT',
    categoryId: 'content_and_experience',
  },
];

export const LMI_CATEGORY_MAP = LMI_CATEGORIES.reduce((previous, current) => {
  previous[current.categoryId] = current;
  return previous;
}, {});

export const LMI_CATEGORIES_BY_NAME = LMI_CATEGORIES.reduce((previous, current) => {
  previous[current.name] = current;
  return previous;
}, {});

export const LMI_CATEGORIES_WITH_REGIONAL_GRADES: string[] = ['listings'];

export const LMI_CATEGORY_ENUM_MAP = {
  0: 'NOT_SET',
  1: 'WEBSITE',
  2: 'CONTENT_AND_EXPERIENCE',
  3: 'LISTINGS',
  4: 'REPUTATION',
  5: 'SEO',
  6: 'SOCIAL',
  7: 'ADVERTISING',
};

export const LMI_CATEGORY_TITLE_ENUM_MAP = {
  NOT_SET: 0,
  WEBSITE: 1,
  CONTENT_AND_EXPERIENCE: 2,
  LISTINGS: 3,
  REPUTATION: 4,
  SEO: 5,
  SOCIAL: 6,
  ADVERTISING: 7,
};
